import React from 'react';
import { Bubble, BubbleProps } from 'tea-component';

// 内容为空则不调用 Bubble，防止影响性能
const CommonBubble = (props: BubbleProps) => {
  const { content, children,  ...rest } = props;

  return (
    <>
      {
        content ? <Bubble content={content} {...(rest || {})}>
          {children}
        </Bubble> : children
      }
    </>
  );
};

export default CommonBubble;
